import { IdentityDocument } from '@dreryk/egabinet-patient-published-language-api';

import { PassportIdentityDocumentEditModal } from '../edit/PassportIdentityDocumentEditModal';
import { PassportIdentityDocumentEnterModal } from '../enter/PassportIdentityDocumentEnterModal';

const hasIdentityDocument = (identityDocument: IdentityDocument | undefined): identityDocument is IdentityDocument => {
   return Boolean(identityDocument);
};

const isPassportIdentityDocumentType = (
   identityDocument: IdentityDocument | undefined
): identityDocument is IdentityDocument => {
   return hasIdentityDocument(identityDocument) && identityDocument.getType() === 'PASSPORT';
};

type PassportIdentityDocumentValidModalProps = {
   readonly patientId: number;
   readonly identityDocument: IdentityDocument | undefined;
   readonly onValidIdentityDocumentEntered: () => Promise<void>;
   readonly onCancel: VoidFunction;
   readonly onSuccess: VoidFunction;
};

export const PassportIdentityDocumentValidModal = (props: PassportIdentityDocumentValidModalProps): JSX.Element => {
   if (isPassportIdentityDocumentType(props.identityDocument)) {
      return (
         <PassportIdentityDocumentEditModal
            identityDocument={props.identityDocument}
            patientId={props.patientId}
            onCancel={props.onCancel}
            onSuccess={props.onSuccess}
            onIdentityDocumentUpdated={props.onValidIdentityDocumentEntered}
         />
      );
   }

   return (
      <PassportIdentityDocumentEnterModal
         hasAnotherIdentityDocument={hasIdentityDocument(props.identityDocument)}
         patientId={props.patientId}
         onIdentityDocumentEntered={props.onValidIdentityDocumentEntered}
         onCancel={props.onCancel}
         onSuccess={props.onSuccess}
      />
   );
};
